import { Injectable } from "@angular/core";
import { Observable, fromEvent } from "rxjs";


import { ApiService } from "./apiService";
import { SecurityService } from "./security.service";

// FIXME (DO-4549) - this should be a directive defining the [telemetry] attribute and using a @HostListener
/** @deprecated - this should be a directive defining the [telemetry] attribute and using a @HostListener */
@Injectable()
export class AccessLogHandlerService
{
    private readonly documentMouseUp: Observable<Event> = fromEvent(document, "mouseup");

    constructor(
        private readonly $apiService: ApiService,
        private readonly $securityService: SecurityService)
    { }

    start(isTest: boolean): void
    {
        if (isTest)
        {
            return;
        }

        this.documentMouseUp.subscribe(($event: MouseEvent) =>
        {
            this.logAccess($event.target as HTMLElement);
        });
    }

    private excludeLogging(label: string): boolean
    {
        return label === "Search-SelectSetting";
    }

    private getBrowser(): string
    {
        const agent = window.navigator.userAgent.toLowerCase();
        switch (true)
        {
            case agent.indexOf("edge") > -1:
                return "Edge";
            case agent.indexOf("edg/") > -1:
                return "Edge (chromium based)";
            case agent.indexOf("opr") > -1 && !!window["opr"]:
                return "Opera";
            case agent.indexOf("chrome") > -1 && !!window["CefSharp"] && !!window["webLauncher"]:
                return "WebLauncher";
            case agent.indexOf("chrome") > -1 && !!window["CefSharp"]:
                return "CefSharp";
            case agent.indexOf("chrome") > -1 && !!window["chrome"]:
                return "Chrome";
            case agent.indexOf("trident") > -1:
                return "Internet Explorer";
            case agent.indexOf("firefox") > -1:
                return "Firefox";
            case agent.indexOf("safari") > -1:
                return "Safari";
            case agent.indexOf("samsungbrowser") > -1:
                return "Samsung Internet";
            case agent.indexOf("silk") > -1:
                return "Amazon Silk";
            default:
                return agent;
        }
    }

    private getCommandBarTelemetry(element: HTMLElement): string
    {
        if (element.getAttribute("isTelemetryCommand"))
        {
            const originalElement = element;
            while (element && element.tagName !== "COMMAND-BAR")
            {
                element = element.parentElement;
            }

            if (element)
            {
                const commandBarTelemetry = element.getAttribute("attr.telemetry");
                if (commandBarTelemetry)
                {
                    return `${commandBarTelemetry}-${originalElement.getAttribute("telemetry")}`;
                }
            }
        }
        return null;
    }

    private getDevice(): string
    {
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent))
        {
            return "tablet";
        }

        if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent))
        {
            return "mobile";
        }

        return "desktop";
    }

    private isMenuItem(element: HTMLElement): boolean
    {
        return element && element.role === "menuitem"
            && (element.tagName.toLowerCase() === "forge-list-item" || element.tagName.toLowerCase() === "button");
    }

    private logAccess(element: HTMLElement): void
    {
        try
        {
            const token = this.$securityService.principle;
            if (!token)
            {
                return;
            }

            let event: string;
            if (this.isMenuItem(element))
            {
                event = element.innerText;
            }
            else
            {
                const commandBarElementTelemetry = this.getCommandBarTelemetry(element);
                if (commandBarElementTelemetry)
                {
                    event = commandBarElementTelemetry;
                }
                else
                {
                    while (element && !element.getAttribute("telemetry") && element.tagName !== "BODY")
                    {
                        element = element.parentElement;
                    }

                    if (element
                        && element.getAttribute("telemetry")
                        && !this.excludeLogging(element.getAttribute("telemetry")))
                    {
                        event = element.getAttribute("telemetry");
                    }
                }
            }

            if (!event)
            {
                return;
            }
            const data = {
                Event: event,
                Url: location.href,
                Persona: token.UserPersona,
                Device: this.getDevice(),
                Browser: this.getBrowser(),
                UserId: token.Username,
                SerializedRowState: "Added",
            };
            this.$apiService.sendAuth("IAccessLogService/LogAccess", data);
        }
        catch (error)
        {
            return;
        }
    }
}
